import {useState} from "react";

import {ContactService} from "contact/service";
import {contact_view_adapter} from "contact/model";

import {useNavigateWithReload} from "base/navigation/hooks";
import {useErrors} from "base/error/provider/ErrorProvider";

import {ContactData} from "contact/presentational";
import {ContactForm} from "contact/presentational/form";
import {
    SectionCardHeaderAction,
    SubSectionCardHeader,
} from "base/ui/section/components";
import {DeleteItemDialog} from "base/delete/components";

import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import PermContactCalendarOutlinedIcon from "@mui/icons-material/PermContactCalendarOutlined";

const ViewOrUpdateContactDataContent = ({permit, contact, allowEdit = true}) => {
    const navigate = useNavigateWithReload();
    const {handleErrors} = useErrors();

    const [mode, setMode] = useState("view");
    const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);

    const handleDelete = () => {
        ContactService.delete(contact.id).then(() => {
            navigate("", true);
        });
    };

    const handleFormSubmit = contact => {
        ContactService.update(contact_view_adapter(contact))
            .then(updatedContact => {
                setMode("view");
                navigate("", true);
            })
            .catch(error => {
                handleErrors(error);
            });
    };

    const actions = [
        <SectionCardHeaderAction
            key="edit"
            name="edit"
            text="Modificar"
            icon={<EditIcon />}
            onClick={() => {
                setMode("edit");
            }}
        />,
        <SectionCardHeaderAction
            key="delete"
            name="delete"
            text="Remover"
            icon={<DeleteIcon color="error" />}
            onClick={() => {
                setIsDeleteDialogOpen(true);
            }}
        />,
    ];

    const getComponent = mode => {
        if (mode === "view") {
            return <ContactData contact={contact} />;
        }
        if (mode === "edit") {
            return (
                <ContactForm
                    permitId={permit?.id}
                    contact={contact}
                    onSubmit={handleFormSubmit}
                    onCancel={() => {
                        setMode("view");
                    }}
                />
            );
        }
    };

    return (
        <Card sx={{border: 1, borderRadius: 2, borderColor: "grey.300"}} elevation={0}>
            <SubSectionCardHeader
                titleLabel="Contacto"
                titleValue={contact.name}
                icon={<PermContactCalendarOutlinedIcon />}
                actions={allowEdit ? actions : null}
            />
            <CardContent>{getComponent(mode)}</CardContent>
            <DeleteItemDialog
                isDialogOpen={isDeleteDialogOpen}
                setIsDialogOpen={setIsDeleteDialogOpen}
                onDelete={handleDelete}
            />
        </Card>
    );
};

export default ViewOrUpdateContactDataContent;
